import React from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import * as ErrorAction from "../../../../../Redux/ErrorRedux";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Container from "../../../../../modules/commons/Container";
import { HttpStatus } from "../../../../common/Constants";
import { mapToObjectDDL } from "../../../../common/mapper";
import LaporanUnitHarian from "./laporanUnitHarian/laporanUnitHarian";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import LaporanServiceHarian from "./laporanServiceHarian/laporanServiceHarian";
import LaporanMTD from "./laporanMTD/laporanMTD";
import LaporanServiceYTD from "./laporanServiceYTD/laporanServiceYTD";
import LaporanUnitL3Y from "./laporanUnitL3Y/laporanUnitL3Y";

class DashboardLaporanHarianUnitByMekanik extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dataCabang: [],
      kodeCabang: null,
      search: {},
    };
  }

  componentDidMount = async () => {
    this.fetchDataCabang();
  };

  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleChangeDoSearch = (value) => {};

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName:
        "Dashboard Level Kepala Bengkel Keatas - Laporan Harian Unit By Mekanik",
      args: null,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      let filteredData = res.data.data
        .filter((item) =>
          this.props.menuAccess
            .map((data) => data.idRefObj)
            .includes(item.kodeCabang),
        )
        .map((item) => mapToObjectDDL(item.namaDealer, item.kodeCabang));

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang: filteredData,
          kodeCabang: filteredData[0],
        }));
      }
    }
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleChangeCabang = (value) => {
    this.setState((prevValue) => ({ ...prevValue, kodeCabang: value }));
  };

  render() {
    const { loading, kodeCabang, dataCabang } = this.state;
    return (
      <React.Fragment>
        <Container>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <SimpleDDL
              id="select_options_kode_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-350px margin-top-15px"
              placeholder="Nama Cabang"
              options={dataCabang}
              value={kodeCabang}
              onChange={(value) => this.handleChangeCabang(value)}
            />
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Unit Entri Harian</Tab>
              <Tab>Laporan Unit Servis Harian</Tab>
              <Tab>Laporan Servis Harian</Tab>
              <Tab>Laporan Servis MTD</Tab>
              <Tab>Laporan Unit Entri MTD By Mekanik</Tab>
              <Tab>Laporan Unit Servis MTD By Mekanik</Tab>
              <Tab>Laporan Servis YTD</Tab>
              <Tab>Laporan Unit Entri 3 Tahun Terakhir</Tab>
              <Tab>Laporan Unit Servis 3 Tahun Terakhir</Tab>
            </TabList>
            <TabPanel>
              <LaporanUnitHarian
                type="unit_entri"
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanUnitHarian
                type="service"
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanServiceHarian
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanMTD
                type="service"
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanMTD
                type="unit_entri"
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanMTD
                type="unit_service"
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanServiceYTD
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanUnitL3Y
                type="unit_entri"
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
            <TabPanel>
              <LaporanUnitL3Y
                type="service"
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                kodeCabang={kodeCabang}
              />
            </TabPanel>
          </Tabs>
        </Container>
        {loading && <SimpleLoadingOverlay active={loading} />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(
  null,
  mapDispatchToProps,
)(DashboardLaporanHarianUnitByMekanik);
